module.exports = __webpack_public_path__ + "img/option2.80a35242.webp";